import { combineReducers } from "redux";

import userDataReducer from "./reducer_userData";
import formStatusReducer from "./reducer_caseActions";
import referenceReducer from "./reducer_reference";
// import allUserAppianCasesReducer from "../../../components/Case/reducers/reducer_allAppianCases";
import allUserAppianICertCasesReducer from "../../../components/PWDCasesSearch/CERTCasesSearch/reducer_icert";

const appReducer = combineReducers({
  userDataReducer,
  formStatusReducer,
  allUserAppianICertCasesReducer,
});

export default appReducer;
